import SaleTypesData from './SaleTypesData'
import { useSaleTypesData } from './useSaleTypesData'
import { useSaleTypesAsArray } from './useSaleTypesAsArray'


export default SaleTypesData
export { useSaleTypesData, useSaleTypesAsArray }
